<!-- 运维视图: 当前事件 -->
<template>
    <el-card class="box-card" @mouseenter.native="stopRefresh" @mouseleave.native="startRefresh">
        <div slot="header" class="clearfix">
            <span>当前事件</span>
            <div class="float-r">
                <dictionary-select v-model="level" :factory-name="'domain'" :params="'TICKETLEVEL'"
                                   :clearable="true" size="small" :width100="false" @change="query">
                </dictionary-select>
            </div>
        </div>
        <el-row class="bottom20">
          <el-table
                  :data="page.records" v-loading="loading"
                  height="376"
                  stripe
                  style="width: 100%">
              <el-table-column prop="code" label="事件编号">
                  <template slot-scope="scope">
                      <span @click="toIncidentDetail(scope.row)">
                          <el-link href="javascript:void(0);" type="primary">
                              {{scope.row.ticketid}}
                          </el-link>
                      </span>
                  </template>
              </el-table-column>
              <el-table-column prop="description" label="事件主题">
                  <template slot-scope="scope">
                      <span>{{scope.row.description}}</span>
                  </template>
              </el-table-column>

              <el-table-column prop="level" label="事件等级">
                  <template slot-scope="scope">
                      <dictionary-text :factory-name="'domain'" :params="'TICKETLEVEL'" :value="scope.row.level">
                      </dictionary-text>
                  </template>
              </el-table-column>

              <el-table-column prop="status" label="开始时间">
                  <template slot-scope="scope">
                      {{scope.row.actualstart | substring(19)}}
                  </template>
              </el-table-column>
              <el-table-column prop="status" label="状态">
                  <template slot-scope="scope">
                      <dictionary-text :factory-name="'domain'" :params="'INCIDENTSTATUS'" :value="scope.row.status">
                      </dictionary-text>
                  </template>
              </el-table-column>
              <el-table-column label="操作">
                  <template slot-scope="scope">
                      <el-button v-if="scope.row.status === 'WACCEPT'" @click="accept(scope.row)" :plain="true"
                                 size="small">接单
                      </el-button>
                  </template>
              </el-table-column>
          </el-table>
        </el-row>

        <el-row type="flex" class="row-bg" justify="end">
          <el-pagination @size-change="setPageSearchSize"
                         @current-change="setPageSearchCurrent"
                         :current-page="pageSearch.current"
                         :page-size="pageSearch.size"
                         :page-sizes="[5, 10, 25, 50, 100]"
                         layout="total, sizes, prev, pager, next, jumper"
                         :total="page.total">
          </el-pagination>
        </el-row>
    </el-card>
</template>

<script>
    import DictionarySelect from "@/components/common/DictionarySelect";
    import DictionaryText from "@/components/common/DictionaryText";
    import {
        findSimpleIncidentByLogbook,
    } from "@/views/board/operation/operation-board-order-service";
    import {addParamsToUrl} from "@/util";
    import {acceptIncident, requestAndAcceptIncident} from "@/service/ticket-service"

    // 是否启动定时刷新
    const TIMER_REFRESH_ENABLED = true;
    // 刷新间隔
    const REFRESH_INTERVAL = 30000;

    export default {
        name: "operation-board-ticket",
        components: {
            DictionaryText,
            DictionarySelect
        },
        props: {
            params: {},
            logbook: {},
        },
        data() {
            return {
                refreshIntervalId: null,
                level: null,
                pageSearch: {
                  current: 1,
                  size: 5,
                },
                page: {
                  total: 0,
                  records: [],
                },
                loading: false,
            };
        },
        computed: {},
        watch: {
            params: {
                deep: true,
                immediate: true,
                handler() {
                    this.query();
                }
            },
          'pageSearch.current': {
            deep: false,
            immediate: false,
            handler() {
              this.query();
            },
          },
          'pageSearch.size': {
            deep: false,
            immediate: false,
            handler() {
              if (this.pageSearch.current === 1) {
                this.query();
              } else {
                this.setPageSearchCurrent(1);
              }
            },
          },
        },
        methods: {
          setPageSearchCurrent(current) {
            this.pageSearch.current = current;
          },
          setPageSearchSize(size) {
            this.pageSearch.size = size;
          },
            async load() {
                let page = {
                  total: 0,
                  records: [],
                };
                let current = this.pageSearch.current;
                let size = this.pageSearch.size;
                let params = this.params == null ? null : JSON.parse(JSON.stringify(this.params));
                if (params != null) {
                    let levels = [];
                    if (this.level != null && this.level !== '') {
                        levels = [this.level];
                    }
                    // NOTE: 查询前一天到当天的时间段
                    params.startdate = null;
                    params.enddate = null;
                    page = await findSimpleIncidentByLogbook(current, size, params, {
                        levels: levels,
                        status: ['WACCEPT', 'WHANDLE']
                    });
                    // console.log(page);
                    // incidents.sort((a, b) => {
                    //     let flag;
                    //     if (a.status === 'WACCEPT' && b.status !== 'WACCEPT') {
                    //         flag = -1;
                    //     } else if (a.status !== 'WACCEPT' && b.status === 'WACCEPT') {
                    //         flag = 1;
                    //     } else if (a.level < b.level) {
                    //         flag = -1;
                    //     } else if (a.level < b.level) {
                    //         flag = 1;
                    //     } else if (a.actualstart < b.actualstart) {
                    //         flag = 1;
                    //     } else if (a.actualstart > b.actualstart) {
                    //         flag = -1;
                    //     } else {
                    //         flag = 0;
                    //     }
                    //     return flag;
                    // });
                }
                this.page = page;
                return Promise.resolve(page);
            },
            query() {
                this.loading = true;
                this.load().finally(() => {
                    this.loading = false;
                });
            },
            toIncidentDetail(row) {
                let url = `${process.env.VUE_APP_WEB_API}/ticket?m=5111`;
                let urlParams = {
                    ticketid: row.ticketid,
                    TICKETID: row.ticketid,
                    ticketuid: row.ticketuid,
                    dcnum: row.dcnum,
                    receiveTicketeRportnum: row.reportNum
                };
                window.open(addParamsToUrl(url, urlParams));
            },
            accept(ticket) {
                if (ticket.enterbyusername != 'incident') {
                    acceptIncident(ticket).then(() => {
                        this.$message.success(`接单成功，${ticket.ticketid}`);
                        this.query();
                    }).catch(e => {
                        this.$message.error(e);
                        this.query();
                    });
                } else {
                    requestAndAcceptIncident(ticket).then(() => {
                        this.$message.success(`接单成功，${ticket.ticketid}`);
                        this.query();
                    }).catch(e => {
                        this.$message.error(e);
                        this.query();
                    });
                }
            },
            refresh() {
                // this.query();
                if (this.pageSearch.current === 1) {
                    this.query(); // current = 1，主动调用查询
                } else {
                    // 不是第一页，回到第一页，页长不变，watch会自动查询
                  this.pageSearch.current = 1;
                }
            },
            startRefresh() {
                if (TIMER_REFRESH_ENABLED) {
                    this.refreshIntervalId = setInterval(() => this.refresh(), REFRESH_INTERVAL);
                }
            },
            stopRefresh() {
                if (this.refreshIntervalId != null) {
                    clearInterval(this.refreshIntervalId);
                }
            },
        },
        mounted() {
            this.startRefresh();
        },
        filters: {
            substring(value, max) {
                return value.length > max ? value.substring(0, max) : value;
            },
        },
    }
</script>

<style scoped>
    a.el-link.is-underline {
        text-decoration: none;
    }
</style>
